export default __webpack_public_path__ + "static/logo_black-bb7504e3e8998c6fac70f87eb954e4a6.svg";